<template>
    <div class="mb main bg-white col">
            <div class="top-block top-row row">
            <h2 class="landingPageTitle txt-black fontGrot">Comment ça marche ?</h2>
            <div class="top-row-right-block col">
                <p class="txt-content txt-black fontGrot">Pour postuler, rien de plus simple.
Ce service gratuit vous permet d’envoyer votre candidature à l’ensemble des entreprises qui recrutent. D’ici quelques jours, vous serez mis en contact avec un recruteur potentiel. </p>
                <div class="ButtonContainer">
                    <button class="txt-black fontGrot" @click="redirectToDemo">Je postule</button>
                </div>
            </div>
        </div>
            <div class="block4-row row">
                <div class="block4-col col">
                    <img class="block4-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/landing-page-postulez.png"/>
                    <div class="black-block-temp"></div>
                    <p class="img-txt-content txt-black fontGrot">Postulez</p>
                </div>
                <div id="mid-block4-col" class="block4-col col">
                    <img class="block4-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/landing-page-%C3%A9changez.png"/>
                    <div class="black-block-temp"></div>
                    <p class="img-txt-content txt-black fontGrot">Échangez</p>
                </div>
                <div class="block4-col col">
                    <img class="block4-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/landing-page-commencez.png"/>
                    <div class="black-block-temp"></div>
                    <p class="img-txt-content txt-black fontGrot">Commencez</p>
                </div>
            </div>
        </div>
  </template>
  
  <script>
  export default {
    name: "PageBlock4",
    methods: {
      redirectToDemo() {
        // window.location.href = "https://jobnavigator.fr/web/index.php/candidature/index#apply";
        const utmSource = "olecio_job";
        window.location.href = `https://jobnavigator.fr/web/index.php/candidature/index#apply?utm_source=${encodeURIComponent(utmSource)}`;
        // window.location.href = "https://demo.jobnavigator.fr/web/index.php/candidature/index#apply";
      }
    }
  };
  </script>
  
  <style src="../pages/landing-page.scss" lang="scss"></style>
  <style scoped>
  .img-txt-content {
    text-align: start;
    font-weight: 600;
  }
  .txt-content {
    text-align: start;
  }
.img-txt-content,
.txt-content {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .block4-row {
    justify-content: center;
  }
  .top-row {
    margin-top: 2.25rem;
    margin-bottom: 2rem;
    justify-content: center;
    align-items: start;
  }
  #mid-block4-col {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  /* .black-block-temp {
    background-color: black;
    height: 300px;
    width: 300px;
  } */
  .block4-img {
    height: 200px;
    width: 300px;
  }
  .ButtonContainer {
    display: flex;
    margin-bottom: 2rem;
  }
  .ButtonContainer button {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .mb {
    margin-bottom: 2rem;
  }
.landingPageTitle {
    text-align: start;
    margin-top:1rem;
    font-size: 2.75rem;
    line-height: 3rem;
    margin-left: 7.5rem;
    flex-basis: 60%;
}
.top-row-right-block {
    padding-left: 4.5rem;
    padding-right: 8rem;
}
  #olecio-logo {
    max-width: 8rem;
    margin-bottom: 2rem;
  }
  button {
    margin-top: 1.15rem;
    padding: 15px 40px;
    background-color: #e54021;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media screen and (max-width: 460px) {
    .mb{
      margin-bottom: 0rem;
    }
    .top-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .block4-row {
      display: none;
    }
    .landingPageTitle{
      text-align: center;
      font-size: 1.875rem;
      line-height: 2.25rem;
      margin-left: 0rem;
      margin-bottom: 1rem;
    }
    .top-row-right-block{
      padding-left: 2rem;
      padding-right: 2rem;
    }
    .txt-content{
      text-align: center;
    }
    .ButtonContainer {
    margin-bottom: 4rem;
    justify-content: center;
  }
  .col,
  .top-row{
    margin-bottom: 0rem;
  }
    /* .left-block .txt-content{
      text-align: center;
      padding-left: 2rem;
      padding-right: 2rem;
    } */
  }
  </style>